import { FilterActions } from "../constants/constants";

const initialFilters = {
    stageIds: [],
    levelIds: [],
    cardCategoryIds: [],
    protocolgroupIds: [],
    protocolIds: [],
    status: [],
    appartmentIds: [],
    zoneIds: [],
    customcardId: [],
    cardsGroupIds: null,
    volume: null,
    area: null,
    surface: null,
    height: null,
    bimElements: [],
    isDelayed: false,
    demoUrl: '',
    historicalObservations: false,
    timelineSelect: 'start_date',
    customcardTypes: [],
    dateRange: 'personalized',
    usersInCharge: []
}

const filterActionsMap = {
    [FilterActions.STAGES]: 'stageIds',
    [FilterActions.LEVELS]: 'levelIds',
    [FilterActions.CARD_CATEGORIES]: 'cardCategoryIds',
    [FilterActions.PROTOCOLGROUPS]: 'protocolgroupIds',
    [FilterActions.PROTOCOLS]: 'protocolIds',
    [FilterActions.STATUS]: 'status',
    [FilterActions.APPARTMENTS]: 'appartmentIds',
    [FilterActions.ZONES]: 'zoneIds',
    [FilterActions.CUSTOMCARD]: 'customcardId',
    [FilterActions.CARDS_GROUP_IDS]: 'cardsGroupIds',
    [FilterActions.VOLUME]: 'volume',
    [FilterActions.AREA]: 'area',
    [FilterActions.SURFACE]: 'surface',
    [FilterActions.HEIGHT]: 'height',
    [FilterActions.BIM_ELEMENTS]: 'bimElements',
    [FilterActions.IS_DELAYED]: 'isDelayed',
    [FilterActions.DEMO_URL]: 'demoUrl',
    [FilterActions.HISTORICAL_OBSERVATIONS]: 'historicalObservations',
    [FilterActions.TIME_SELECT]: 'timelineSelect',
    [FilterActions.CUSTOMCARD_TYPES]: 'customcardTypes',
    [FilterActions.DATE_RANGE]: 'dateRange',
    [FilterActions.USERS_IN_CHARGE]: 'usersInCharge',
}

const filtersReducer = (data = initialFilters, action) => {
    let type = filterActionsMap[action.type];
    let newData = {...data};
    if (type) {
        newData[type] = action.data;
    }
    return newData;
}

export default filtersReducer;